import React, { useEffect, useState } from "react";
import infoIcon from "../../assets/images/svg/info.svg";

// position : "down" | "right"

export default function OverflowingText({
  text = "--",
  textClassName = "tax_report_instrument_name",
  ellipsisTextClassName = "",
  width = 200,
  position = "down",
  tooltipOnHover = false,
  tooltipClassName = "",
  forPage = false,
  buttonAriaLabel = "Information",
  id = "tooltip-data",
  buttonStyle = { pointerEvents: "auto" },
  tooltipStyle = {},
  children,
}) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [showTooltip, setShowTooltip] = useState({});

  const ref = React.createRef(null);

  useEffect(() => {
    if (ref.current) {
      let compareWidth = ref?.current?.clientWidth < ref?.current?.scrollWidth;

      if (tooltipOnHover) {
        const tempSpan = document.createElement("span");
        tempSpan.innerText = `${text}`;
        tempSpan.style.visibility = "hidden";
        if (forPage === "tax") {
          tempSpan.style.fontSize = "14px";
          tempSpan.style.color = "red";
          tempSpan.style.fontFamily = "Encode Sans";
        }

        document.body.appendChild(tempSpan);
        const spanWidth = tempSpan.offsetWidth;
        document.body.removeChild(tempSpan);
        compareWidth = width - `${forPage !== "tax" ? 0 : 19}` < spanWidth;
      }
      if (compareWidth) setIsOverflowing(true);
      else setIsOverflowing(false);
    }
    // eslint-disable-next-line
  }, [ref?.current, text, width]);

  return (
    <>
      <div
        className={`broker_name ${textClassName}`}
        style={{ display: "flex" }}
      >
        <p
          ref={ref}
          onMouseOver={() => {
            isOverflowing &&
              setShowTooltip({ visibility: "visible", opacity: 1 });
          }}
          onMouseEnter={() =>
            isOverflowing &&
            setShowTooltip({ visibility: "visible", opacity: 1 })
          }
          onMouseLeave={() => isOverflowing && setShowTooltip({})}
          style={{
            cursor:
              isOverflowing || (isOverflowing && tooltipOnHover)
                ? "pointer"
                : "auto",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width: width - 19,
            whiteSpace: "nowrap",
          }}
          className={ellipsisTextClassName}
        >
          {children ? children : text}
        </p>
        {(isOverflowing || tooltipOnHover) && (
          <div
            className="info_icon_tooltip"
            style={{
              alignItems: "center",
              position: "relative",
              width: tooltipOnHover ? 0 : 18,
            }}
          >
            {!tooltipOnHover && (
              <button
                className={"info_img clickable tooltip-button"}
                style={{
                  height: "24px",
                  width: "24px",
                  pointerEvents: "auto",
                  right: "-1px",
                  position: "absolute",
                  top: "-5px",
                  ...buttonStyle,
                }}
                aria-describedby={id}
                aria-label={buttonAriaLabel}
              >
                <img className="" src={infoIcon} alt="" />
              </button>
            )}

            {isOverflowing && (
              <p
                className={`${
                  position === "down"
                    ? "td_tooptip"
                    : position === "right"
                      ? "td_tooptip_right"
                      : "td_tooptip_left"
                } ${tooltipClassName}`}
                style={{
                  whiteSpace: "normal",
                  maxWidth: "350px",
                  ...showTooltip,
                  ...tooltipStyle,
                }}
                id={id}
                role="tooltip"
              >
                {text}
              </p>
            )}
          </div>
        )}
      </div>
    </>
  );
}
